import { render } from "./IconReaction.vue?vue&type=template&id=278f992e&scoped=true"
import script from "./IconReaction.vue?vue&type=script&lang=js"
export * from "./IconReaction.vue?vue&type=script&lang=js"

import "./IconReaction.vue?vue&type=style&index=0&id=278f992e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278f992e"]])

export default __exports__